export const TELEMETRY_ACTIONS = {
  PAGE: 'Page',
  REPORTSTATUS: 'ReportStatus',
  DOWNLOAD: 'Download'
};
